import styled from 'styled-components';
import { Label } from 'semantic-ui-react';
import { useDndGridInternalContext } from './context';
import React from 'react';
import { ReactComponent as ChartPlaceholder } from '../../assets/images/chart-placeholder.svg';
import { ReactComponent as ChartPlaceholderDisabled } from '../../assets/images/chart-placeholder-disabled.svg';

const DragOverlayWrapper = styled.div`
  position: relative;
  width: 128px; // same as SVG width
  line-height: 1; // undo Semantic's default line-height
`;

const DropDisableOverlayMessage = styled(Label)`
  position: absolute;
  &&&& {
    margin-top: 6px;
    background-color: #e6597f;
    font: inherit;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #fff;
  }
`;

export const ChartDragOverlay = () => {
  const { currentCanDrop } = useDndGridInternalContext();
  return (
    <DragOverlayWrapper>
      {currentCanDrop.canDrop ? (
        <ChartPlaceholder />
      ) : (
        <>
          <ChartPlaceholderDisabled />
          <DropDisableOverlayMessage pointing>
            {currentCanDrop.reason}
          </DropDisableOverlayMessage>
        </>
      )}
    </DragOverlayWrapper>
  );
};
